import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CancellationStatusesComponent } from './cancellation-statuses.component';
import { ColorCircleModule } from 'ngx-color/circle';

const routes: Routes = [
  { path: '', component: CancellationStatusesComponent, data: { title: 'Cancellation Statuses' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes), ColorCircleModule],
  exports: [RouterModule],
})
export class CancellationStatusesRoutingModule {}

@NgModule({
  imports: [
    CancellationStatusesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ColorCircleModule,
  ],
  declarations: [CancellationStatusesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CancellationStatusesComponent],
})
export class CancellationStatusesModule {}
